import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { SokusaiManagementChangePasswordSentComponent } from './sokusai-management-change-password-sent/sokusai-management-change-password-sent.component';
import { SokusaiManagementForgotPasswordComponent } from './sokusai-management-forgot-password/sokusai-management-forgot-password.component';
import { SokusaiManagementInputComponent } from './sokusai-management-input/sokusai-management-input.component';
import { SokusaiManagementLoginComponent } from './sokusai-management-login/sokusai-management-login.component';
import { SokusaiManagementOemHeaderComponent } from './sokusai-management-oem-header/sokusai-management-oem-header.component';
import { SokusaiManagementOemLoginMessageComponent } from './sokusai-management-oem-login-message/sokusai-management-oem-login-message.component';
import { SokusaiManagementOemRegisterMessageComponent } from './sokusai-management-oem-register-message/sokusai-management-oem-register-message.component';
import { SokusaiManagementPasswordInputComponent } from './sokusai-management-password-input/sokusai-management-password-input.component';
import { SokusaiManagementRegisterResendComponent } from './sokusai-management-register-resend/sokusai-management-register-resend.component';
import { SokusaiManagementRegisterSendComponent } from './sokusai-management-register-send/sokusai-management-register-send.component';
import { SokusaiManagementRegisterComponent } from './sokusai-management-register/sokusai-management-register.component';
import { SokusaiManagementResetPasswordComponent } from './sokusai-management-reset-password/sokusai-management-reset-password.component';
import { SokusaiManagementUnblockComponent } from './sokusai-management-unblock/sokusai-management-unblock.component';
import { SokusaiManagementComponent } from './sokusai-management/sokusai-management.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    SokusaiManagementComponent,
    SokusaiManagementLoginComponent,
    SokusaiManagementRegisterComponent,
    SokusaiManagementUnblockComponent,
    SokusaiManagementRegisterResendComponent,
    SokusaiManagementRegisterSendComponent,
    SokusaiManagementForgotPasswordComponent,
    SokusaiManagementResetPasswordComponent,
    SokusaiManagementChangePasswordSentComponent,
    SokusaiManagementInputComponent,
    SokusaiManagementPasswordInputComponent,
    SokusaiManagementOemHeaderComponent,
    SokusaiManagementOemRegisterMessageComponent,
    SokusaiManagementOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SokusaiManagementResetPasswordComponent,
    SokusaiManagementComponent,
    SokusaiManagementRegisterResendComponent,
    SokusaiManagementRegisterSendComponent,
    SokusaiManagementUnblockComponent,
    SokusaiManagementChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SokusaiManagementModule {}
